<template>
  <div id="introduction">
    <div class="introduction-content">
      <div class="introduction-banner">
        <img src="../../../static/images/introduction-banner.jpg" alt="">
      </div>

      <div class="introduction-main">

        <div class="introduction-detail" v-html="intcontnt"></div>

      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import NavDom from '@/components/navtop/navloginbefore'
export default {
  name: 'Introduction',
  data() {
    return {
      intcontnt: ''
    }
  },
  created () {
    this.getConpy();
  },
  methods: {
    getConpy() {
      let _this = this;
      _this.$http({
        method: 'get',
        url: _this.$api + '/sys/company'
      }).then((response) => {
        if(response.data.code == 200) {
          _this.intcontnt = response.data.data;
          console.log(response.data.data);
        }
      })
    }
  },
  components: {
    NavDom
  }
}
</script>

<style lang="stylus" scoped>
  .introduction-banner
    img
      width 100%

  .introduction-main
    width 1080px
    margin 0 auto

    .introduction-detail
      margin 22px 0 30px 0

    
</style>



// WEBPACK FOOTER //
// src/components/about/introduction.vue